import type { EntityAvatarColorKey } from "./entityAvatar.types";

/**
 * Maps semantic entity color keys to Tailwind classes for badge rings and chips.
 */
export const entityAvatarColorMap: Record<EntityAvatarColorKey, string> = {
  action: "bg-eoe-entity-action border-eoe-entity-action",
  issue: "bg-eoe-entity-issue border-eoe-entity-issue",
  feedback: "bg-eoe-entity-feedback border-eoe-entity-feedback",
  solution: "bg-eoe-entity-solution border-eoe-entity-solution",
  collection: "bg-sky-600 border-sky-600",
  "impact-positive": "bg-eoe-entity-impact-positive border-eoe-entity-impact-positive",
  "impact-negative": "bg-eoe-entity-impact-negative border-eoe-entity-impact-negative",
  "impact-inactive": "bg-eoe-entity-impact-inactive border-eoe-entity-impact-inactive",
  teabate: "bg-eoe-entity-teabate border-eoe-entity-teabate",
  user: "bg-eoe-entity-user border-eoe-entity-user",
  team: "bg-eoe-entity-team border-eoe-entity-team",
  "eoe-gray": "bg-eoe-gray border-eoe-gray",
};

/**
 * Avatar thumbnail size classes, keyed by the shared `ACTOR_AVATAR_SIZES`
 * px scale (`util/actorAvatarSizes`). Tailwind cannot build class names
 * dynamically, so this static map is the bridge from the size tokens to
 * markup — use it instead of hardcoding `h-8 w-8` etc. in presentation
 * code (SOC-UI-DS-0006, #597).
 */
export const entityAvatarSizeClass = {
  /** 16px — `ACTOR_AVATAR_SIZES.mini`; actor mini-avatar in entity rows. */
  mini: "size-4",
  /** 32px — `ACTOR_AVATAR_SIZES.message`; actor avatar in the default identity row. */
  actorRow: "size-8",
  /** 36px — `ACTOR_AVATAR_SIZES.header`; the standard entity thumbnail (all row/chip modes). */
  thumb: "size-9",
  /** 48px — `ACTOR_AVATAR_SIZES.inboxRow`; `displayMode="avatarOnly"`. */
  standalone: "size-12",
} as const;

/**
 * Crosspost source-type chip background (legacy mapping preserved for visual parity).
 */
export function crosspostSourceChipClass(sourceType: string): string {
  const map: Record<string, string> = {
    impact: "bg-eoe-entity-impact-positive",
    solution: "bg-eoe-entity-solution",
    feedback: "bg-eoe-entity-feedback",
    action: "bg-eoe-entity-action",
  };
  return map[sourceType] ?? "bg-gray-500";
}
